import type { ReactNode } from 'react'

import { CollectionSuggestionsCollapse } from './CollectionSuggestionsCollapse'

import styles from './CollectionSuggestionsSection.module.css'

export type TCollectionSuggestionItem = {
    key: string
    content: ReactNode
}

type TCollectionSuggestionsSectionProps = {
    title: string
    items: TCollectionSuggestionItem[]
    /** "Listen next" holds a single card and stays open, as in audio-web `CollectionSuggestions`. */
    collapsible?: boolean
}

export const CollectionSuggestionsSection = ({
    title,
    items,
    collapsible = true,
}: TCollectionSuggestionsSectionProps) => {
    const list = (
        <ul className={styles.list}>
            {items.map(item => (
                <li key={item.key}>{item.content}</li>
            ))}
        </ul>
    )

    return (
        <section className={styles.section}>
            <h2 className={styles.title}>{title}</h2>
            {collapsible ? (
                <CollectionSuggestionsCollapse>{list}</CollectionSuggestionsCollapse>
            ) : (
                list
            )}
        </section>
    )
}
